import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, Form, FormGroup, Validators } from '@angular/forms';
import { OtpModelBoxComponent } from '../otp-model-box/otp-model-box.component';
import { MatDialog } from '@angular/material/dialog';
import { IwService } from 'src/app/services/iw.service';
import { QdeService } from 'src/app/services/qde.service';
import { OtpStatusValues } from 'src/app/utilities/utilities.file';
import { GENERIC_ERRORS, ISTATACARD, VALIDATION_MSG, GENERIC_ERROR } from 'src/app/config/app-settings.config';
import { ThemePalette } from '@angular/material';
import { ThemeService } from 'src/app/services/theme.service';

@Component({
  selector: 'app-existing-user',
  templateUrl: './existing-user.component.html',
  styleUrls: ['./existing-user.component.scss']
})
export class ExistingUserComponent implements OnInit {
  firstNumber: any;
  secondNumber: any;
  thirdNumber: any;
  fourthNumber: any;
  resultValue : boolean;
  existingDetailForm: FormGroup;
  eapplyFormLabel: any;
  otpStatus: any;
  genericErrors: any;
  otpSuccess: boolean;
  btnDisabled: boolean = true;
  existingJourneyCounter = 0;
  existingJourneyCounterValidate = 0;
  TATACARD = ISTATACARD;
  somePlaceholder : String ="xxxx-xxxx-xxxx-xxxx";
  public creditCardRegex = "^(?:(?<visa>4[0-9]{12}(?:[0-9]{3})?)|" +
    "(?<mastercard>5[1-5][0-9]{14})|" +
    "(?<discover>6(?:011|5[0-9]{2})[0-9]{12})|" +
    "(?<amex>3[47][0-9]{13})|" +
    "(?<diners>3(?:0[0-5]|[68][0-9])?[0-9]{11})|" +
    "(?<jcb>(?:2131|1800|35[0-9]{3})[0-9]{11}))$";
  validCard: boolean;
  validationMsgs:any;
  minimumLength:any=16;

  @Input() cardDcrData: any;
  cardName: any;
  partnerCode: any = sessionStorage.getItem('partner-code');
  containerType: any = sessionStorage.getItem('container-type');

  constructor(
    private fb: FormBuilder, 
    public dialog: MatDialog, 
    public iwService: IwService, 
    private qdeService: QdeService,
    private themeService: ThemeService){ 
      this.partnerCode = this.themeService.partnerCode;
    }
  successMessage = this.qdeService.successMessageOTP;
  errorMessage = this.qdeService.errorMessageOTP;

  ngOnInit() {
    this.genericErrors = GENERIC_ERRORS;
    this.validationMsgs = VALIDATION_MSG;
    this.successMessage = this.qdeService.successMessageOTP;
    this.errorMessage = this.qdeService.errorMessageOTP;
    this.createForm();
    this.eapplyFormLabel = this.iwService.geteapplyFormLabelDcr().dcrContent.root;
    const xml = this.cardDcrData;
    if (xml && xml.root && xml.root.card_information && xml.root.card_information.card_name) {
      this.cardName = xml.root.card_information.card_name;
    }
  }

  ngOnChanges() {
    this.successMessage = this.qdeService.successMessageOTP;
    this.errorMessage = this.qdeService.errorMessageOTP;
  }
  get f() {
    return this.existingDetailForm.controls;
  }
  createForm() {
    this.existingDetailForm = this.fb.group({
      fcnCreditCardNumber: ['', [Validators.required]], 
      fcnMobileNumber: ["",[Validators.required, Validators.pattern("^([3-9]{1}[0-9]{9})$")]],
      fcnDeclaration: ['', Validators.requiredTrue]

    })
  }
/*
  displayCardNumber() {
    if (this.f.fcnCreditCardNumber) {
      this.firstNumber = this.f.fcnCreditCardNumber.value.slice(0, 4);
      this.secondNumber = this.f.fcnCreditCardNumber.value.slice(4, 8);
      this.thirdNumber = this.f.fcnCreditCardNumber.value.slice(8, 12);
      this.fourthNumber = this.f.fcnCreditCardNumber.value.slice(12, 16) 
    }
  }
  */
 displayCardNumber() {
  if (this.f.fcnCreditCardNumber){
    var amexPattern = /^(?:3[0-9]{0,})$/;
    var ccNum = this.f.fcnCreditCardNumber.value;
    var isAmex = amexPattern.test(ccNum) === true;
    if(isAmex)
    {
      this.minimumLength=15;
      this.somePlaceholder = "xxxx-xxxxxx-xxxxx"
      this.firstNumber = this.f.fcnCreditCardNumber.value.slice(0,4);
      this.secondNumber = this.f.fcnCreditCardNumber.value.slice(4,10);
      this.thirdNumber = this.f.fcnCreditCardNumber.value.slice(10,15);
      this.fourthNumber = this.f.fcnCreditCardNumber.value.slice(15,15);
    }
    else{
      this.minimumLength=16;
      this.somePlaceholder = "xxxx-xxxx-xxxx-xxxx"
      this.firstNumber = this.f.fcnCreditCardNumber.value.slice(0,4);
      this.secondNumber = this.f.fcnCreditCardNumber.value.slice(4,8);
      this.thirdNumber = this.f.fcnCreditCardNumber.value.slice(8,12)+ ' '+ '-';
      this.fourthNumber = this.f.fcnCreditCardNumber.value.slice(12,16);

    }
  }

 }
  

modten(inputNum) {       
  let digit, digits, flag, sum, _i, _len, _result;
  flag = true;
  sum = 0;
  digits = (inputNum.target.value + '').split('').reverse();        
  for (_i = 0, _len = digits.length; _i < _len; _i++) {       
    digit = digits[_i];      
    digit = parseInt(digit, 10);          
    if ((flag = !flag)) {                      
      digit *= 2;               
    }
    if (digit > 9) {               
      digit -= 9;                    
    }      
    sum += digit;          
  }
  if(sum % 10 ===0){
    _result = true
  }
  else{
    _result = false;
  }
  this.resultValue = _result;
  this.resultValue = !this.resultValue;
  return _result;
} 

openDialogAndSendOtp() {
  if (this.f.fcnMobileNumber.invalid) {
    this.f.fcnMobileNumber.markAsTouched();
    return;
  } else {
    const dialogRef = this.dialog.open(OtpModelBoxComponent, {
      disableClose: true,
      data: {
        mobileNumber: this.f.fcnMobileNumber.value,
        creditCardNo: this.f.fcnCreditCardNumber.value,
        existingJourneyCounter: this.existingJourneyCounter,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.existingJourneyCounter = result.counter;
        if (this.existingJourneyCounter >= 5) {
          this.btnDisabled = true;
        } else {
          this.btnDisabled = false;
        }
        if (result.status && result.status.status.toLowerCase() === 'success') {
          this.successMessage = `${this.genericErrors.existingCustomerSaveSuccess1}${this.cardName}${this.genericErrors.existingCustomerSaveSuccess2}`;
          this.qdeService.successMessageOTP = this.successMessage;
          this.errorMessage ='';
          this.qdeService.errorMessageOTP = this.errorMessage;
          this.btnDisabled = true;
        } else if(result.error){
          this.successMessage ='';
          this.qdeService.successMessageOTP = this.successMessage;
           this.errorMessage = GENERIC_ERROR;
           this.qdeService.errorMessageOTP = this.errorMessage;
        } else if(result.status){
          this.successMessage='';
          this.qdeService.successMessageOTP = this.successMessage;
          this.errorMessage = this.genericErrors.existingCustomerSaveFailure;
          this.qdeService.errorMessageOTP = this.errorMessage;
        }else{
          this.successMessage='';
          this.qdeService.successMessageOTP = this.successMessage;
          this.errorMessage = GENERIC_ERRORS.otpError;
          this.qdeService.errorMessageOTP = this.errorMessage;
        }
      }
    });
  }
}

sendOtp() {
  if (this.existingDetailForm.invalid) {
    Object.keys(this.f).forEach(key => {
      this.existingDetailForm.get(key).markAsTouched();
    });
    return;
  } else {
    this.qdeService
      .generateOtp(this.f.fcnCreditCardNumber.value,this.f.fcnMobileNumber.value, "false", '110')
      .subscribe(
        (result: any) => {
          if (
            result.OTPGenerationRsType.statusDesc.toLowerCase() === "success" &&
            result.OTPGenerationRsType.statusCode == "000"
          ) {
            this.otpStatus = OtpStatusValues.OTP_GENERATED;
            this.otpSuccess = true;
            this.btnDisabled = true;
            this.existingJourneyCounter += 1;
            this.openDialogAndSendOtp();
          } else if (result.OTPGenerationRsType.statusCode != "000") {
            this.otpStatus = OtpStatusValues.OTP_NOT_GENERATED;
            this.otpSuccess = false;
            this.errorMessage = result.OTPGenerationRsType.statusDesc;
          }
        }, error => {
          this.otpSuccess = false;
          this.errorMessage = this.genericErrors.error;
        }
      );
  }
}

enableOtpButton() {
  if (this.f.fcnMobileNumber.value.length < 10) {
    this.btnDisabled = true;
  } else { 
    if(this.successMessage || this.existingJourneyCounter>=5 || this.qdeService.counterValidate>=5){
      this.btnDisabled = true;
    } else{
      this.qdeService.existingJCounterValidate=0;
      this.btnDisabled = false;
    }
  }

}

numberOnly(event) {
  let regex = /[0-9]/;
  if (event.key.match(regex)) {
    return true;
  } else {
    return false;
  }

}
}
